import { RuleTableHandlers, TableConfig } from "../../../../../shared/ui/custom-table/model/table-config.model";

export function createRealStateInvestmentTableConfig(
  handlers: RuleTableHandlers = {},
  options: { filterView?: string } = {}
): TableConfig {
  const {
    onAction = () => { },
    actionMap = {},
    onRowClick = () => { },
    onRowDblClick = () => { },
    onRowExpand = () => { },
    selectable = false,
    summaryTemplate,
    rowConfig = {},
    headerActions,
    gridActions,
    columns,
  } = handlers;

  const handleAction = (row: any, action: TableRowAction) => {
    if (actionMap[action]) {
      actionMap[action](row);
    } else {
      onAction(row, action);
    }
  };

  return {
    columns: columns || [],
    actions: [
      { label: 'Editar', icon: 'edit', callback: (row) => handleAction(row, TableRowAction.Edit) },
      { label: 'Pagos', icon: 'payment', callback: (row) => handleAction(row, TableRowAction.Pay) },
      { label: 'Contabilizar (asiento libre)', icon: 'show_chart', callback: (row) => handleAction(row, TableRowAction.Contabilizar) },
      {
        label: 'Descargar documento (imagen)', icon: 'image',
        visible: (row) => !!row && row.isImage === true,
        callback: (row) => handleAction(row, TableRowAction.DownloadImage),
      },
      {
        label: 'Descargar documento (PDF)', icon: 'attach_file',
        visible: (row) => !!row && row.isPdf === true,
        callback: (row) => handleAction(row, TableRowAction.DownloadPdf),
      },
      { label: 'Eliminar', icon: 'delete', callback: (row) => handleAction(row, TableRowAction.Delete) },
    ],
    headerActions: headerActions,
    gridActions: gridActions,
    filterView: options.filterView || 'realStateInvestment',
    rowConfig: {
      ...rowConfig,
      clickable: true,
      onClick: onRowClick,
      onDoubleClick: onRowDblClick,
      onExpand: onRowExpand,
    },
    selectable: selectable,
    pagination: true,
    summaryTemplate: summaryTemplate,
  };
}

export enum TableRowAction {
  Edit = 'edit',
  Delete = 'delete',
  DownloadImage = 'downloadImage',
  DownloadPdf = 'downloadPdf',
  Pay = 'pay',
  Contabilizar = 'contabilizar',
}
